export const CREATE_DEVICE_SETTINGS = 'CREATE_DEVICE_SETTINGS';
export const EDIT_DEVICE_SETTINGS = 'EDIT_DEVICE_SETTINGS';
export const SHOW_DEVICE_SETTINGS = 'SHOW_DEVICE_SETTINGS';
export const DEVICE_SETTINGS_SUCCESS = 'DEVICE_SETTINGS_SUCCESS';
export const DEVICE_SETTINGS_ERROR = 'DEVICE_SETTINGS_ERROR';

